// 📁 components/Reports/Inventory/StockValueByBranchChart.jsx
import React from 'react';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip as RechartsTooltip, ResponsiveContainer, Cell
} from 'recharts';
import { Paper, Typography, Skeleton } from '@mui/material';
import { formatMoney } from '../../../utils/currency';

const StockValueByBranchChart = ({ data = {}, branches = [], loading }) => {
  const chartData = branches.map(branch => ({
    name: branch.name,
    value: data[branch.id] || 0,
    color: branch.color
  }));

  return (
    <Paper elevation={2} sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" gutterBottom>
        💰 Productos en sucursal (costo)
      </Typography>
      {loading ? (
        <Skeleton variant="rectangular" height={300} />
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <BarChart data={chartData} margin={{ top: 20, left: 10, right: 20, bottom: -10 }}>
            <XAxis dataKey="name" />
            <YAxis />
            <RechartsTooltip formatter={(value) => `${formatMoney(value)}`} />
            <Bar dataKey="value">
              {chartData.map((entry, index) => (
                <Cell key={index} fill={entry.color} />
              ))}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </Paper>
  );
};

export default StockValueByBranchChart;
